// extracted by mini-css-extract-plugin
export default {"footerContent":"SignedCommitFooter-module__footerContent--DwpR0","Link":"SignedCommitFooter-module__Link--LhWOg","Link_1":"SignedCommitFooter-module__Link_1--eqhdc"};